export enum SubscriptionInterval {
  MONTHLY = "monthly",
  ANNUAL = "annual",
}

export enum SubscriptionName {
  // latest subscription
  TEN_DAY_FREE_TRIAL_MONTHLY = "free_trial_monthly",
  TEN_DAY_FREE_TRIAL_ANNUAL = "free_trial_annual",
  ONE_SEAT_MONTHLY = "one_seat_monthly",
  ONE_SEAT_ANNUAL = "one_seat_annual",

  // legacy subscriptions, these can be removed once subscriptionsV2 is deleted.
  OUTDATED_THREE_DAY_FREE_TRIAL_MONTHLY = "3_day_free_trial_monthly",
  OUTDATED_THREE_DAY_FREE_TRIAL_ANNUAL = "3_day_free_trial_annual",
  OUTDATED_FIVE_SEAT_MONTHLY = "five_seat_monthly",
  OUTDATED_FIVE_SEAT_ANNUAL = "five_seat_annual",
}

export type PianoOffer = {
  offerId: string;
  /** human-readable subscription name, used for analytics */
  subscriptionName: string;
  termId: string;
};
